'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, LayoutContainer, LinkList, LinkListItem, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { FaqSeo } from '@libs/common-next';
import { Accordion } from '@libs/shared-ui/components/Accordion';
import { parseRichContentToPlainText, parseRichText } from '../../utils/parseRichText';
import { useItems } from '../../utils/useItems';
import { FaqStoreCards } from './FaqStoreCards';
import type { FaqProps } from './types';
import './Faq.scss';
export default function Faq(t0) {
  const $ = _c(29);
  const {
    variant,
    headline,
    subHeader,
    lineItem
  } = t0;
  const faqItems = useItems(lineItem, variant);
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== faqItems || $[1] !== headline || $[2] !== subHeader || $[3] !== variant) {
    const panelClassnames = cn({
      "faq-question": variant === "FAQ"
    });
    const t7 = variant === "Store Cards";
    let t8;
    if ($[11] !== t7) {
      t8 = cn("faq", {
        "faq-centered": t7
      });
      $[11] = t7;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    const containerClassName = t8;
    T0 = LayoutContainer;
    t6 = "sparky-u-width-100";
    t3 = containerClassName;
    if ($[13] !== headline) {
      t4 = <Heading size="title" tagName="h2">{headline}</Heading>;
      $[13] = headline;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    if ($[15] !== subHeader) {
      t5 = subHeader && <TextPassage className="faq-subheader">{subHeader}</TextPassage>;
      $[15] = subHeader;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t1 = "faq-accordions";
    t2 = faqItems.map(items => <div className="faq-accordion-group" key={items.at(0)?.sysId}><Accordion items={items.map(group => ({
        id: group.sysId,
        title: group.question,
        className: panelClassnames,
        children: <LinkList className={cn("faq-list", {
          "faq-list-cards": variant === "Store Cards"
        })}>{variant === "Columns" && group.answers.map(_temp)}{variant === "FAQ" && parseRichText(group.answer)}{variant === "Store Cards" && group?.storeCards && <FaqStoreCards key={group.sysId} answers={group.storeCards} />}</LinkList>
      }))} /><FaqSeo id="faq-seo" qaArray={items.map(_temp2)} /></div>);
    $[0] = faqItems;
    $[1] = headline;
    $[2] = subHeader;
    $[3] = variant;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t7) {
    t8 = <div className={t3}>{t4}{t5}{t7}</div>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== T0 || $[26] !== t6 || $[27] !== t8) {
    t9 = <T0 className={t6}>{t8}</T0>;
    $[25] = T0;
    $[26] = t6;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp2(item) {
  return {
    question: item.question,
    answer: parseRichContentToPlainText(item.answer)
  };
}
function _temp(a) {
  return <LinkListItem key={a.sysId} text={a.actionText} href={a.link.webUrl} />;
}